module.exports = __webpack_public_path__ + "static/media/productos_apple.92b303d5.png";